const normalizedId = (value) => (value == null ? null : String(value));

export const createSportsnewDetailRequestToken = ({ fixtureId, generation, mode, scope }) => ({
  fixtureId: normalizedId(fixtureId),
  generation,
  mode,
  scope,
});

export const isSportsnewDetailRequestCurrent = ({
  latestRequest,
  request,
  detailFixtureId,
  mode,
  scope,
}) => (
  latestRequest === request
  && normalizedId(detailFixtureId) === request.fixtureId
  && mode === request.mode
  && scope === request.scope
);

export const sportsnewDetailResponseMatchesRequest = (responseFixtureId, request) => (
  normalizedId(responseFixtureId) === request.fixtureId
);

export const canPaintSportsnewDetailCache = (request, cached) => (
  request.mode !== 'live' && cached != null
);
